import { getFunctions, httpsCallable } from 'firebase/functions';
import { app, auth } from '../firebase/firebase';

const PREFIJOS_ERROR_ENVIO = [
  'error al enviar',
  'error al guardar',
  'no se pudo guardar',
];

const obtenerDetalleError = (error) => ({
  codigo: error?.code || null,
  mensaje: error?.message || String(error || 'Error no especificado'),
  nombre: error?.name || null,
});

export const registrarErrorEnvioEjercicio = async (contexto, error) => {
  if (!app || !contexto?.alumnoId) return;

  try {
    const usuarioAuth = auth?.currentUser;
    const functions = getFunctions(app, 'us-central1');
    const registrarFalloEnvioEjercicio = httpsCallable(functions, 'registrarFalloEnvioEjercicio');
    await registrarFalloEnvioEjercicio({
      ...contexto,
      correoAlumno: contexto.correoAlumno || usuarioAuth?.email || 'Correo no disponible',
      ruta: window.location.pathname,
      ...obtenerDetalleError(error),
    });
  } catch (logError) {
    // No se muestra otro aviso al alumno: el fallo original ya está siendo tratado.
    console.warn('No se pudo registrar el error de envío:', logError);
  }
};

// Los módulos históricos capturan sus propios errores y los notifican por console.error.
// Esta capa los unifica sin modificar el comportamiento de cada ejercicio.
export const instalarCapturaErroresEnvio = (obtenerContexto) => {
  const consoleErrorOriginal = console.error;

  console.error = (...argumentos) => {
    consoleErrorOriginal(...argumentos);

    const mensaje = String(argumentos[0] || '').toLowerCase();
    if (!PREFIJOS_ERROR_ENVIO.some((prefijo) => mensaje.startsWith(prefijo))) return;

    const contexto = obtenerContexto();
    if (contexto?.alumnoId) {
      void registrarErrorEnvioEjercicio(contexto, argumentos[1]);
    }
  };

  return () => {
    console.error = consoleErrorOriginal;
  };
};
